import React, { useCallback } from 'react';
import classNames from 'classnames';
import { kebabCase } from 'lodash';

import { RadioButton } from '@/components/generic/RadioButton';

import styles from './SectionToggler.module.scss';

type Props = {
  name: string;
  enabled: boolean | null;
  onToggle(toggle: boolean): void;
  verticalMobileLayout?: boolean;
};

export const SectionToggler = ({ name, enabled, verticalMobileLayout, onToggle }: Props) => {
  const onYesButtonClick = useCallback(() => {
    onToggle(true);
  }, [onToggle]);

  const onNoButtonClick = useCallback(() => {
    onToggle(false);
  }, [onToggle]);

  return (
    <div
      className={classNames(styles.toggler_wrapper, {
        [styles.vertical_toggler]: verticalMobileLayout,
      })}
    >
      <div
        className={styles.radiobutton_wrapper}
        data-testid={kebabCase(`${name}-toggle-yes`)}
        onClick={onYesButtonClick}
      >
        <RadioButton
          className={classNames({ [styles.radio_button_selected]: enabled })}
          selected={enabled === true}
        />
        <span className={styles.label}>Yes</span>
      </div>

      <div
        className={styles.radiobutton_wrapper}
        data-testid={kebabCase(`${name}-toggle-no`)}
        onClick={onNoButtonClick}
      >
        <RadioButton
          className={classNames({ [styles.radio_button_selected]: enabled === false })}
          selected={enabled === false}
        />
        <span className={styles.label}>No</span>
      </div>
    </div>
  );
};
